export default __webpack_public_path__ + "static/media/icons8-hand-with-smartphone-100.cbe6bedc.svg";